export type BranchingErrorKind = "conflict" | "invalid" | "not-found" | "unavailable" | "unknown";

export class BranchingError extends Error {
  kind: BranchingErrorKind;
  override cause: unknown;

  constructor(kind: BranchingErrorKind, message: string, cause?: unknown) {
    super(message);
    this.name = "BranchingError";
    this.kind = kind;
    this.cause = cause;
  }
}
